import React from "react";
import {renderToStaticMarkup} from "react-dom/server";
import Leaflet, {Icon} from "leaflet";
import MuiIcon from "@material-ui/core/Icon/Icon";
import markerIconPng from "leaflet/dist/images/marker-icon.png"
import markerIconShadowPng from "leaflet/dist/images/marker-shadow.png"
export const markerIcon = (icon) => {
    if(!icon) {
        return new Icon({
            iconUrl: markerIconPng,
            shadowUrl: markerIconShadowPng,
            iconSize: new Leaflet.Point(25, 41), //null,//     [25, 41], // size of the icon
            shadowSize:   [50, 64], // size of the shadow
            iconAnchor:   [12, 41], // point of the icon which will correspond to marker's location
            shadowAnchor: [15, 65],  // the same for the shadow
            popupAnchor:  [0, -36] // point from which the popup should open relative to the iconAnchor
        });
    }
    return Leaflet.divIcon({
        html: renderToStaticMarkup(
            <div style={{width: 32, height: 32}}>
                <MuiIcon fontSize={"small"} style={{color: "#454545", fontSize: 32}}>{icon}</MuiIcon>
            </div>

        ),
        iconSize: new Leaflet.Point(25, 41),
        iconAnchor:   [16, 32],
        popupAnchor:  [0, -25],
    })
};